import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { languages } from '@/common/constants'
import useChangeLanguageOnError from '@/configuration/pages/ConfigurationPage/ReturnsPortalConfiguration/ReturnsPortalCopiesPage/hooks/useChangeLanguageOnError/useChangeLanguageOnError'

const useCustomCopy = ({
  onChangeIsActive,
  onChangeCopy,
  copy,
  lang,
  supportedLanguages,
  errors,
  activePreview,
  onPreviewChange,
  onLanguageChange,
}) => {
  const { t } = useTranslation()
  const [selectedCopyLanguage, setSelectedCopyLanguage] = useState(lang)
  const availableLanguages = languages(t)?.filter(lang => supportedLanguages?.includes(lang.value))

  const isPreviewActive = activePreview === copy?.key

  useChangeLanguageOnError(errors, setSelectedCopyLanguage, copy?.key)

  const handleUseCustomCopy = event => {
    onChangeIsActive(event.target.checked, copy?.key)
  }

  const onChangeTextarea = value => {
    onChangeCopy(value, copy?.key, selectedCopyLanguage, 'message')
  }

  const handlePreviewClick = () => {
    if (isPreviewActive) return

    onPreviewChange(copy?.key)
    onLanguageChange?.(selectedCopyLanguage)
  }

  const handleLanguageChange = value => {
    setSelectedCopyLanguage(value)
    if (isPreviewActive) onLanguageChange?.(value)
  }

  return {
    selectedCopyLanguage,
    availableLanguages,
    handleUseCustomCopy,
    onChangeTextarea,
    isPreviewActive,
    handlePreviewClick,
    handleLanguageChange,
  }
}

export default useCustomCopy
